import { ClaimGenerateUuidAdapter } from '../../../adapter';

export default async function ClaimGenerateUuidUsecase(event) {

    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcc.dev.bpimsapps.com');
    const isUAT = url.includes('hcc.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionclaims.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/claim/generate/uuid'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/claim/generate/uuid'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/generate/uuid`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/generate/uuid`;
    // const requestUrl = 'https://partners-api.dev.bpimsapps.com/claim/claim-file/get';

    const payload = {
        ...event
    };

    // handle request
    const result = await ClaimGenerateUuidAdapter(endpoint, JSON.stringify(payload));

    return result;
}
